export const ip = "https://gpt3.ex2.team/api";

export const topQuestionsRoute = "/top";

export const answerRoute = "/answer";

export const updateRoute = "/update";

export const correctRoute = "/correct";
